import { get } from "lodash";
import { http } from "../../../utils/axios/axios";
import { getCustomHeaderAsync } from "../../onboarding/network/network";
import { getDeviceId } from "../../../utils/service-worker";

const APIM_BASE_URL = get(window, "envConfig.REACT_APP_APIM_BASE_URL", "");
const APIM_MESSAGING = get(window, "envConfig.REACT_APP_ADMIN_NOTIFICATION_URL", "");

export interface DeviceRegistrationParams {
  platform: "web";
  pnToken: string;
  lang: string;
  deviceId: string;
}

export const registerDevice = async (params: DeviceRegistrationParams) => {
  const url = `${APIM_BASE_URL}${APIM_MESSAGING}/devices`;
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(await getCustomHeaderAsync()),
  };

  const requestParam = {
    platform: params.platform,
    deviceToken: params.pnToken,
    deviceId: params.deviceId,
  };

  return http.post(url, requestParam, { headers });
};

export const unregisterDevice = async (platform: string = "web") => {
  const url = `${APIM_BASE_URL}${APIM_MESSAGING}/devices`;
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(await getCustomHeaderAsync()),
  };

  const requestParam = {
    platform,
    deviceId: getDeviceId(),
  };

  return http.delete(url, { data: requestParam, headers });
};
